export class UserQuery {
    id: number;
    queryName: string;
    queryJson: string;
    humanReadable: string;
}